/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type EntityLegalTypeEnum = typeof EntityLegalTypeEnum[keyof typeof EntityLegalTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityLegalTypeEnum = {
  benefit_corporation: 'benefit_corporation',
  c_corporation: 'c_corporation',
  limited_partnership: 'limited_partnership',
  llc: 'llc',
  llp: 'llp',
  lllp: 'lllp',
  individual: 'individual',
  irrevocable_trust: 'irrevocable_trust',
  non_profit_corporation: 'non_profit_corporation',
  s_corporation: 's_corporation',
  sole_proprietorship: 'sole_proprietorship',
  revocable_trust: 'revocable_trust',
  non_legal_entity: 'non_legal_entity',
} as const;
